import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';
import { forkJoin } from 'rxjs';
import { AtwUpdateDbComponent } from 'vhobjects-service';
import { FunctionService  } from 'vhobjects-service';

@Component({
  selector: 'atw-newField-text-admin-config',
  templateUrl: './newField-text-admin-config.component.html',
  styleUrls: ['./newField-text-admin-config.component.scss']
})
export class AtwNewFieldTextAdminConfig extends AtwUpdateDbComponent  {
  @Input() objectChoosing: any;
  @Input() device: any
  @Input() class: any;
  @Input() config: any;
  @Input() type: any;
  @Input() staticdata: any;
  template: any;
  lookupGroupArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  currentField: any;
  newFields = [];
  configMode: 'basic' | 'advanced' = 'basic'; 
  isViewAll: boolean = false;
  currentViewAll: any = {};
  styles_field = [
    {
      title: 'Cấu hình chi tiết Hiệu ứng',
      index: 1,
    },
    {
      title: 'cau_hinh_bo_goc',
      index: 2,
    }
  ];
  text_style: any = [
    {
      title: 'Tiêu đề 1',
      fontSize: '68px',
      name: 'h1',
      font: 21
    },
    {
      title: 'Tiêu đề 2',
      fontSize: '48px',
      name: 'h2',
      font: 19
    },
    {
      title: 'Tiêu đề 3',
      fontSize: '36px',
      name: 'h3',
      font: 18
    },
    {
      title: 'Tiêu đề 4',
      fontSize: '26px',
      name: 'h4',
      font: 17
    },
    {
      title: 'Tiêu đề 5',
      fontSize: '20px',
      name: 'h5',
      font: 16
    },
    {
      title: 'Tiêu đề 6',
      fontSize: '18px',
      name: 'h6',
      font: 15
    },
    {
      title: 'Văn bản',
      fontSize: '18px',
      name: 'p',
      font: 14
    },
    {
      title: 'van_ban_quan_trong',
      fontSize: '18px',
      name: 'strong',
      font: 14
    },
    {
      title: 'Văn bản nhỏ',
      fontSize: '16px',
      name: 'small',
      font: 13
    },
    {
      title: 'Trích dẫn',
      fontSize: '18px',
      name: 'Blockquote',
      font: 14
    }
  ];
  /** Danh sách giải thích loại văn bản tương ứng SEO */
  seoTextTypes: any = [
    { tag: 'tieu_de_1', explain: 'dung_cho_tieu_de_chinh', usage: 'chi_dung_mot_lan_trong_trang' },
    { tag: 'tieu_de_2_den_tieu_de_6', explain: 'dung_cho_cac_tieu_de_phu', usage: 'dung_theo_thu_tu_phan_cap_khong_bo_bac' },
    { tag: 'van_ban', explain: 'dung_cho_van_ban' },
    { tag: 'van_ban_quan_trong', explain: 'dung_cho_van_ban', usage: 'chi_de_nhan_y_quan_trong_dung_tiet_che' },
  ];
  effect_hover = [];
  effect_hover_data: any = {};
  newFieldCKEditors: any;
  customize = []

  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    public vhEventMediator: VhEventMediator,
    private http: HttpClient,
    public functionService: FunctionService
  ) {
    super(vhQueryAutoWeb, vhEventMediator, functionService);
   
   }

  ngOnInit() {
    this.getNewFileds();

    // phần này get dữ liệu json
    forkJoin([
      this.http.get('assets/data/objects_sample/basic/customize-newField/customize-newField-template.json'),
      this.http.get('assets/data/effects/text.json'),
    ]).subscribe(([template, effects]: any) => {
      this.template = template
      this.effect_hover = effects;
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type']);
    })



  }

  ngOnChanges(): void {
    if (this.currentField?.field_input_type == 'ckeditor') {
      this.config.padding_bottom ??= {};
      this.config.padding_bottom.p ??= "0px";
    }
    if (this.effect_hover) {
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type'])
      this.customize = this.effect_hover_data?.data?.find(e => e.id == this.config['animation-selected']?.id)?.customize || [];
    }
  }

  getNewFileds() {
    this.vhQueryAutoWeb.getNewFields_byFields({ id_main_sector: { $eq: this.staticdata.id_main_sector } })
      .then((newfields: any) => {
        this.newFields = newfields;

        if (this.staticdata.field_custom) {
          this.currentField = this.newFields.find((field) => field.field_custom == this.staticdata.field_custom);
        }
      });
  }

  /**
* Hàm này dùng để cho phép mở menu config .
* Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
* @param: value
*/
  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }
  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu8: false,
  };

  /**
 * Cập nhật Kiểu văn bản
 */
  handleSetTextStyle(action) {
    this.class['text__content']['font-size'] = this.text_style.find(style => style.name === action)['fontSize'];
    switch (action) {
      case "Blockquote":
        this.class['text__content']['border-left-width'] = '10px';
        this.class['text__content']['padding-left'] = '10px';
        break;
      default:
        this.class['text__content']['border-left-width'] = '0';
        this.class['text__content']['padding-left'] = '0';
    }

    this.handleSetCurveText();

    this.updateObject();
  }

  /**
 * Xử lý kiểu Uốn cong
 */
  handleSetCurveText() {
    var radius = this.config['curve']['radius'] * 1;

    this.class['text__curve-item']['background-image'] = this.class['text__content']['background-image'];
    this.class['text__curve-item']['-webkit-text-fill-color'] = this.class['text__content']['-webkit-text-fill-color'];
    this.class['text__curve-item']['-webkit-background-clip'] = this.class['text__content']['-webkit-background-clip'];
    this.class['text__curve-item']['height'] = radius + 'px';

    this.class['text__curve']['height'] = (radius * 2) + 'px';
    this.class['text__curve']['width'] = (radius * 2) + 'px';
  }

//   /**
//  * Hàm update object vào database.
//  */
//   updateObject() {
//     return this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
//       .then((bool: any) => {

//       })
//   }

//   /**
//  * Cập nhật staticdata vào database.
//  */
//   updateStaticData() {
//     this.vhQueryAutoWeb
//       .updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
//       .then(
//         (bool) => {

//         },
//         (error) => {
//           console.error(error);
//         }
//       );
//   }

//   /**
//   * Hàm update class
//   */
//   updateClass() {
//     this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
//       .then((bool: any) => {

//       })
//   }

//   /**
//  * Hàm update config
//  */
//   updateConfig() {
//     this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_config']: this.config })
//       .then((bool: any) => {

//       })
//   }

  /** Hàm này cho phép chọn options direction của màu gradient
 * @param direction : trả về hướng phối màu được chọn
 * @param event : trả về element được active
 */
  chooseOption(direction, event) {
    this.config['background-image']['background_image_direction'] = direction.direction;
    this.handleSetGradientText();
  }

  /**
* Hàm này thực hiện thêm màu gradient vào array.
*
*/
  addGradient() {
    this.config['background-image']['background_image_arr_gradient'].push(
      `rgba(${this.hexToRGB(this.config['background-image']['background_image_background_color'])}, ${this.config['background-image']['background_image_opacity'] / 100})`
    );
    this.handleSetGradientText();
  }
  /**  Hàm này cho phép xóa phần tử màu gradient trong array bằng index của phần tử đó.
  * @param index : vị trí phần tử muốn xóa
  */
  deleteGradient(index) {
    this.config['background-image']['background_image_arr_gradient'].splice(index, 1);
    this.handleSetGradientText();
  }

  /**
 * Cập nhật Kiểu danh sách đầu dòng, đánh số
 */
  handleListStyle(style: string) {
    if (`${style} inside none` === this.class['text__content--list-style']['list-style']) {
      style = "none";
      this.config['text_type'] = 'p';
    }
    else {
      this.config['text_type'] = 'ul';
    }

    switch (style) {
      case 'disc':
      case 'decimal':
      case 'upper-alpha':
      case 'upper-roman':
        this.class['text__content']['flex-direction'] = 'column';
        this.class['text__content--list-style']['list-style'] = `${style} inside none`;
        break;
      default:
        this.class['text__content']['flex-direction'] = 'row';
        this.class['text__content--list-style']['list-style'] = 'none';
    }

    this.updateObject();
  }

  /** Chuyển đổi mã màu hexadecimal thành mã màu rgba.
   * @param hex : tham số trả về mã màu hex
   * @returns string : trả về chuỗi rgb
   */
  hexToRGB(hex: string): string {
    // Loại bỏ ký tự '#' từ mã hex
    hex = hex.replace('#', '');

    // Tách mã hex thành các thành phần màu
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Trả về giá trị RGB
    return `${r}, ${g}, ${b}`;
  }
  /** Xử lý lấy thông số giá trị background gradient
   * @param event : trả về giá trị từ 0-100
   */
  getValueRangeBackgroundGradient(e) {
    this.config['background-image']['background_image_opacity'] = e.target.value;
    const newArr = this.config['background-image']['background_image_arr_gradient'].map((color) => {
      const parts = color.match(/(\d+(\.\d+)?)/g); // Tách các phần tử màu từ chuỗi rgba
      return `rgba(${parts[0]}, ${parts[1]}, ${parts[2]}, ${this.config['background-image']['background_image_opacity'] / 100})`
    })
    this.config['background-image']['background_image_arr_gradient'] = newArr;

    this.handleSetGradientText();
  }

  // GRADIENT
  /**
   * Cập nhật Gradient
   */
  handleSetGradientText() {
    if (this.config['background-image']['gradient_check']) {
      this.class['text__content']['background-image'] = `linear-gradient(${this.config['background-image']['background_image_direction']} ${this.config['background-image']['background_image_arr_gradient']})`;
      this.class['text__content']['-webkit-text-fill-color'] = 'transparent';
      this.class['text__content']['-webkit-background-clip'] = 'text';
    }
    else {
      this.class['text__content']['background-image'] = 'none';
      this.class['text__content']['-webkit-text-fill-color'] = 'unset';
      this.class['text__content']['-webkit-background-clip'] = 'unset';
    }

    // gradient cho kiểu uốn cong
    if (this.config['curve']['isCurve']) {
      this.class['text__curve-item']['background-image'] = this.class['text__content']['background-image'];
      this.class['text__curve-item']['-webkit-text-fill-color'] = this.class['text__content']['-webkit-text-fill-color'];
      this.class['text__curve-item']['-webkit-background-clip'] = this.class['text__content']['-webkit-background-clip'];
    }

    this.updateClass();
    this.updateConfig();
  }


  /**
 * Cập nhật transform
 */
  handleSetTextRotate() {
    this.class['text__content']['transform'] = `rotate(${this.config['transform']['rotate']}deg)`;
  }

  /**
  * Cập nhật các thuộc tính border-radius
  */
  handleSetBorderRadius() {
    this.class['text__wrapper']['border-top-left-radius'] = this.class['text__wrapper']['border-radius'];
    this.class['text__wrapper']['border-top-right-radius'] = this.class['text__wrapper']['border-radius'];
    this.class['text__wrapper']['border-bottom-left-radius'] = this.class['text__wrapper']['border-radius'];
    this.class['text__wrapper']['border-bottom-right-radius'] = this.class['text__wrapper']['border-radius'];
    this.updateClass();
  }
  /**
   * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetail(event) {
    this.customize = event;
    this.openViewAll(this.styles_field[0])
  }
  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  openbgGradient() {
    document.getElementById('input-gradient').click();
  }

  changeLookupGroup(event) {
    this.staticdata.lookup_group = event;
    this.updateStaticData();
  }

  onChangeFieldCustom(selectedValue: any) {
    this.currentField = this.newFields.find((field) => field.field_custom == selectedValue);
    const { field_input_location, field_input_type, field_display_type } = this.currentField

    let dataUpdate: any = {}

    if (field_input_location == 'user') {
      if (field_input_type.includes('select')) {
        dataUpdate = {
          resize_group: 'input',
          resize_field: 'select__boundary'
        }
      }

      if (field_input_type.includes('input') || field_input_type == 'textarea') {
        dataUpdate = {
          resize_group: 'input',
          resize_field: 'input__boundary'
        }
      }

      if (field_display_type == 'text' && field_input_type == 'ckeditor') {
        dataUpdate = {
          resize_group: 'image',
          resize_field: 'text'
        }
      }
    } else if (field_input_location == 'admin') {
      if (field_display_type.includes('select')) {
        dataUpdate = {
          resize_group: 'input',
          resize_field: 'select__boundary'
        }
      }

      if (field_display_type == 'radio') {
        // dùng group image vì group input phải có [id]="'boundary'+data._id"
        dataUpdate = {
          resize_group: 'image',
          resize_field: 'radio'
        }
      }

      if (field_display_type == 'text') {
        dataUpdate = {
          resize_group: 'text',
          resize_field: 'text'
        }

        if (field_input_type == 'ckeditor') {
          dataUpdate.resize_group = 'image'
        }
      }
    }

    dataUpdate = {
      ...dataUpdate,
      desktop_class: {
        ...this.template[dataUpdate.resize_field]
      },
      tablet_landscape_class: {
        ...this.template[dataUpdate.resize_field]
      },
      tablet_portrait_class: {
        ...this.template[dataUpdate.resize_field]
      },
      mobile_landscape_class: {
        ...this.template[dataUpdate.resize_field]
      },
      mobile_portrait_class: {
        ...this.template[dataUpdate.resize_field]
      },
      staticdata: this.staticdata
    }

        this.staticdata = this.staticdata
    this.class = {
      ...this.template[dataUpdate.resize_field]
    }
    this.objectChoosing.resize_field = dataUpdate.resize_field;
    this.objectChoosing.resize_group = dataUpdate.resize_group;

    this.vhEventMediator.notifyOnConfigChanged({
      status: 'config-changed', 
      code: this.objectChoosing._id, 
    });


    if (this.type == 'admin') {
      if (!this.objectChoosing.hasOwnProperty('fieldUpdate')) this.objectChoosing['fieldUpdate'] = []
      if (!this.functionService.objectsAndBlocksUpdated.some((ele) => ele._id == this.objectChoosing._id)) this.functionService.objectsAndBlocksUpdated.push(this.objectChoosing)
      if (!this.objectChoosing['fieldUpdate'].includes('desktop_class')) this.objectChoosing['fieldUpdate'].push('desktop_class')
      if (!this.objectChoosing['fieldUpdate'].includes('tablet_landscape_class')) this.objectChoosing['fieldUpdate'].push('tablet_landscape_class')
      if (!this.objectChoosing['fieldUpdate'].includes('tablet_portrait_class')) this.objectChoosing['fieldUpdate'].push('tablet_portrait_class')
      if (!this.objectChoosing['fieldUpdate'].includes('mobile_landscape_class')) this.objectChoosing['fieldUpdate'].push('mobile_landscape_class')
      if (!this.objectChoosing['fieldUpdate'].includes('mobile_portrait_class')) this.objectChoosing['fieldUpdate'].push('mobile_portrait_class')
        
      if (!this.objectChoosing['fieldUpdate'].includes('staticdata')) this.objectChoosing['fieldUpdate'].push('staticdata')
      if (!this.objectChoosing['fieldUpdate'].includes('resize_field')) this.objectChoosing['fieldUpdate'].push('resize_field')
      if (!this.objectChoosing['fieldUpdate'].includes('resize_group')) this.objectChoosing['fieldUpdate'].push('resize_group')
      return;
    }

    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, dataUpdate)

    if (field_input_type == 'ckeditor') {
      this.config.padding_bottom ??= {};
      this.config.padding_bottom.p ??= "0px";
    }
  }

  /**
 * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
 * @param event customize sau khi thay đổi
//  */
  // openAnimationDetail(event) {
  //   this.customize = event;
  //   this.openViewAll(this.styles_field[0])
  // }

  // customize = []

  //   /**
  //  * Hàm này dùng để mở rộng phần cấu hình.
  //  * @param field_text : trả về phần tử được chọn của mảng style_field
  //  */
  // openViewAll(field_text) {
  //   this.currentViewAll = field_text;
  //   this.isViewAll = !this.isViewAll;
  // }


  updateTypeDisplay() {
    if (this.config['view-type']['overflow-y'] == 'visible') {
      this.class['text']['overflow-y'] = 'visible';
      this.class['text']['height'] = '100%';
    } else if (this.config['view-type']['overflow-y'] == 'read-more') {
      if (!this.config['view-type'].hasOwnProperty('isOpen')) this.config['view-type']['isOpen'] = false;
      if (!this.config['view-type'].hasOwnProperty('blur_background_color')) this.config['view-type']['blur_background_color'] = '#fff';

      const element = document.getElementById(this.objectChoosing._id);

      this.class['text']['overflow-y'] = this.config['view-type']['isOpen'] ? 'visible' : 'hidden';
      this.class['text']['height'] = this.config['view-type']['isOpen'] ? `${element.scrollHeight}px` : `${this.config?.dimension?.height}px` || '100%';
      this.class['text']['transition'] = '0.3s';
    } else {
      this.class['text']['overflow-y'] = this.config['view-type']['overflow-y'];
      this.class['text']['height'] = `${this.config?.dimension?.height}px` || '100%';
    }

    this.updateClass();
    this.updateConfig();
  }








}
